// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-form[data-v-b13a3024]{padding:10px 0}.search-form[data-v-b13a3024] .is-guttered{display:flex;align-items:center;white-space:nowrap}.custom-table-header>th[data-v-b13a3024]{background:#dfdfdf!important}.custom-table-header>th>.cell[data-v-b13a3024]{font-family:Alibaba PuHuiTi-Medium,Alibaba PuHuiTi;font-weight:500;color:#868686!important;line-height:22px}.hbn-content[data-v-b13a3024] .el-table .cell{color:#32383d}", ""]);
// Exports
module.exports = exports;
